// extracted by mini-css-extract-plugin
module.exports = {"softkey":"Softkey_softkey__1151L"};